<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/25/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="rhtj mar-t2">
                    <img class="top" src="./../assets/imgs/25/title-1.png" alt="" />
                    <div class="content">
                        <div class="title" style="
                                        font-weight: normal;
                                        font-size: 0.28rem;
                                        margin-top: 0.13rem;
                                    ">
                            <span
                                class="hollow-cricle"></span>青羊区引进的创新创业人才是指：从区外引入、具有硕士研究生及以上学历或副高及以上职称、年龄原则上不超过55周岁、服务于纳税关系在青羊区的企事业单位、每年在青羊区所属企业工作6个月以上的各类人才。研发水平（拥有核心技术的产品）处于国内领先、具有较大的产业发展潜力的创新创业人才，可以适当放宽学历和年龄限制。主要包括以下五类人才：
                        </div>
                        <div class="des mar-t2">
                            <div class="label">
                                <div class="letter">A</div>
                                <span>专家人才</span>
                            </div>
                            诺贝尔奖获得者、国家最高科学技术奖获得者、国务院特殊津贴获得者、国家有突出贡献中青年专家、国家“万人计划”“千人计划”入选者；省部级以上学术技术带头人、有突出贡献的优秀专家、四川省“千人计划”入选者；成都市批准的其他高层次创新创业人才。
                        </div>
                        <div class="des mar-t2">
                            <div class="label">
                                <div class="letter">B</div>
                                <span>自主创业人才</span>
                            </div>
                            拥有自主知识产权或发明专利，且技术成果先进、能够填补国内空白、引领主导产业发展，为我区带来重大经济和社会效益的创新人才。
                        </div>
                        <div class="des mar-t2">
                            <div class="label">
                                <div class="letter">C</div>
                                <span>领军人才</span>
                            </div>
                            承担过与国家科技重大项目相关的重要任务、具有较强的产品研发能力和产业化潜力的领军人才，以及能够解决关键技术和工艺操作性难题的领军人才。
                        </div>
                        <div class="des mar-t2">
                            <div class="label">
                                <div class="letter">D</div>
                                <span>创业人才</span>
                            </div>
                            自带来源清晰，无知识产权权属纠纷的项目来我区创办企业，企业注册资本不低于100万元，且自筹资金（含技术入股）或跟进的风险投资占创业投资的50%以上，或作为主要创办人，股权不低于30%的创业人才。
                        </div>
                        <div class="des mar-t2">
                            <div class="label">
                                <div class="letter">E</div>
                                <span>急需紧缺人才</span>
                            </div>
                            经区人才工作领导小组研究同意，并报成都市批准引进的急需紧缺人才。
                        </div>
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/25/title-2.png" alt="" />
                    <div class="content">
                        <div class="des">
                            （一）到青羊区创办企业或到青羊区企业工作且签订3年及以上劳动合同（或引进协议）的A、B、C、D、E五类创新创业人才，经批准后，分别给予最高50万元、40万元、30万元、20万元、10万元的安家补贴，在3年内按资助总额20%、30%、50%的比例逐年发放到位。安家补贴主要用于搬家、装修、购置交通工具和生活用品等。
                        </div>
                        <div class="des">
                            <div>
                                （二）批准引进的创新创业人才可选择享受以下住房优惠政策。
                            </div>
                            <div>
                                <span style="font-weight: bold">1.租房补贴。</span>
                                自行租房的可享受租房补贴，标准为A类每月5000元、B类每月4000元、C类每月3000元、D类每月2000元、E类每月1000元。补贴资金按年度一次性发放，期限3年。
                            </div>
                            <div>
                                <span style="font-weight: bold">2.购房补贴。</span>
                                本人及家庭成员在成都五城区（含高新区）区域内无登记住房，自批准引进之日起三年内在成都市行政区域内购买自住房的，可享受购房补贴。补贴标准为A类50万元、B类40万元、C类30万元、D类20万元、E类10万元。补贴资金分3年按补贴总额50%、30%、20%的比例逐年发放。
                            </div>
                            <div>
                                在享受租房补贴期间购买商品房的，可再申请购房补贴，但购房补贴总额应当扣除已享受的租房补贴部分。
                            </div>
                        </div>
                        <div class="des">
                            （三）批准引进的创新创业人才来我区创办企业，对办公用房有需求的，根据其办公用房使用面积（最高不超过100㎡）给予3年房租补贴，按第1年不超过50元/㎡/月、第2年不超过30元/㎡/月、第3年不超过20元/㎡/月的标准执行。
                        </div>
                    </div>
                </div>
                <div class="sbcl">
                    <img class="top" src="./../assets/imgs/25/title-3.png" alt="" />
                    <div class="content">
                        <div class="des">
                            <div class="title">（一）申报引进人才认定材料</div>
                            <div class="item">
                                <div class="dot">1</div>
                                《青羊区创新创业人才认定申请表》；
                            </div>
                            <div class="item">
                                <div class="dot">2</div>
                                用人单位的“统一社会信用代码”执照或法人营业执照、组织机构代码证、税务登记证原件和复印件；
                            </div>
                            <div class="item">
                                <div class="dot">3</div>
                                用人单位的完税证明原件和复印件；
                            </div>
                            <div class="item">
                                <div class="dot">4</div>
                                认定创新创业人才的有关凭证，包括有效文件、证书、身份证或护照、毕业证、学位证和职称证原件和复印件等；
                            </div>
                            <div class="item">
                                <div class="dot">5</div>
                                引进人才与用人单位签订的劳动合同（或引进协议）原件及复印件；
                            </div>
                            <div class="item">
                                <div class="dot">6</div>
                                本人近期2寸免冠照2张。
                            </div>
                        </div>
                        <div class="des">
                            <div class="title">（二）申报人才安家补贴材料</div>
                            <div class="item">
                                <div class="dot">1</div>
                                《青羊区创新创业人才安家补贴申请表》；
                            </div>
                            <div class="item">
                                <div class="dot">2</div>
                                《成都市青羊区创新创业人才证书》原件和复印件；
                            </div>
                            <div class="item">
                                <div class="dot">3</div>
                                用人单位为人才缴纳的社会保险清单。
                            </div>
                        </div>
                        <div class="des">
                            <div class="title">（三）申报人才租房补贴材料</div>
                            <div class="item">
                                <div class="dot">1</div>
                                《青羊区创新创业人才租房补贴申请表》（附件4）；
                            </div>
                            <div class="item">
                                <div class="dot">2</div>
                                引进人才本人或配偶（需提供结婚证）签署的租房合同（或协议）原件及复印件；
                            </div>
                            <div class="item">
                                <div class="dot">3</div>
                                引进人才及家庭成员在成都五城区（含高新区）无登记住房证明。
                            </div>
                        </div>
                        <div class="des">
                            <div class="title">（四）申报人才购房补贴材料</div>
                            <div class="item">
                                <div class="dot">1</div>
                                《青羊区创新创业人才购房补贴申请表》；
                            </div>
                            <div class="item">
                                <div class="dot">2</div>
                                引进人才本人及家庭成员在成都五城区（含高新区）区域内无登记住房证明；
                            </div>
                            <div class="item">
                                <div class="dot">3</div>
                                新购房房产证明材料（房产证、购房合同等原件及复印件）。
                            </div>
                        </div>
                        <div class="des">
                            <div class="title">
                                （五）申报办公用房租金补贴材料
                            </div>
                            <div class="item">
                                <div class="dot">1</div>
                                《青羊区创新创业人才办公用房补贴申请表》；
                            </div>
                            <div class="item">
                                <div class="dot">2</div>
                                创业项目介绍；
                            </div>
                            <div class="item">
                                <div class="dot">3</div>
                                企业资质证明材料（“统一社会信用代码”执照或法人营业执照、组织机构代码证、税务登记证原件和复印件）；
                            </div>
                            <div class="item">
                                <div class="dot">4</div>
                                办公用房租房合同（或协议）原件及复印件。
                            </div>
                        </div>
                    </div>
                </div>
                <div class="gmlc">
                    <img class="top" src="./../assets/imgs/25/title-4.png" alt="" />
                    <div class="content">
                        <div class="des mar-t3">
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">1</div>
                                    <div class="line-title">申报</div>
                                </div>
                                <div class="line-content">
                                    引进的创新创业人才由用人单位向行业主管部门或辖区街道办事处申报。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">2</div>
                                    <div class="line-title">初审</div>
                                </div>
                                <div class="line-content">
                                    区委人才办组织进行初审和考察，提出初步建议人选。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">3</div>
                                    <div class="line-title">评审</div>
                                </div>
                                <div class="line-content">
                                    区委人才办牵头组织专家评审，对初审合格的人选具体申报项目进行评估审核，形成评审通过的人选和评审结果。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">4</div>
                                    <div class="line-title">公示</div>
                                </div>
                                <div class="line-content">
                                    区委人才办将评审通过的人选和评审结果向社会进行公示，公示期不得低于7个工作日。经公示无异议的，或虽有异议但经区委人才办核实后不存在相关问题的，由区委人才办形成相关工作建议报区人才工作领导小组审定。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">5</div>
                                    <div class="line-title">审定</div>
                                </div>
                                <div class="line-content">
                                    由区委人才工作领导小组召开专题会议对区委人才办提出的相关工作建议进行审定。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line-num">6</div>
                                    <div class="line-title">公布结果</div>
                                </div>
                                <div class="line-content">
                                    经审定无异议的，由区委人才办向社会发布公告，为引进人才颁发《成都市青羊区创新创业人才证书》，兑现奖励政策。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contact" style="margin-top: 0.8rem">
                    <img class="top" src="./../assets/imgs/25/title-5.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-86259119">028-86259119</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            中共成都市青羊区委组织部人才科
                        </div>
                        <!-- <div>
                                    政策咨询电话：
                                    <a href="tel:028-86259119">028-86259119</a>
                                </div>
                                <div>责任单位：中共成都市青羊区委组织部人才科</div> -->
                    </div>
                </div>
                <div class="codes">
                    <img class="code" src="../assets/imgs/25/code.png" />
                    <img class="text" src="../assets/imgs/25/text.png" />
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.87rem 0.23rem 0.3rem;
                    text-align: left;
                    line-height: 0.44rem;
                    position: relative;
                    overflow: hidden;

                    .label {
                        width: 2.17rem;
                        height: 0.6rem;
                        background: #739bfe;
                        position: absolute;
                        top: 0;
                        display: flex;
                        left: 0;
                        align-items: center;
                        padding-left: 0.11rem;

                        color: #fff;

                        .letter {
                            width: 0.36rem;
                            height: 0.36rem;
                            background-color: #ffffff;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border-radius: 0.25rem 0px 0px 0px;
                            color: #739bfe;
                            margin-right: 0.12rem;
                            transform: translateY(-0.02rem);
                        }
                    }
                }
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.5rem;
                    position: relative;
                }
            }
        }

        .sbcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.5rem;
                    position: relative;

                    .title {
                        font-size: 0.3rem;
                        font-weight: bold;
                        color: #333333;
                    }

                    .item {
                        margin-top: 0.22rem;
                        box-sizing: border-box;
                        position: relative;
                        padding-left: 0.42rem;
                        display: flex;

                        .dot {
                            width: 0.39rem;
                            height: 0.39rem;
                            background-color: #739bfe;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.28rem;
                            color: #fff;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.1rem;
                            top: 0;
                            z-index: 9999;
                        }
                    }
                }
            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.55rem auto;
                padding: 0 0.33rem 0.35rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 100%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .line-title {
                            font-size: 0.3rem;
                            font-weight: bold;
                            color: #3d5aa3;
                        }

                        .line-top {
                            display: flex;
                            width: 3.31rem;
                            height: 0.49rem;
                            background-image: url(../assets/imgs/25/label.png);
                            background-size: 100% 100%;
                            z-index: 99;
                            display: flex;
                            align-items: center;
                            box-sizing: border-box;
                            padding-left: 0.08rem;

                            .line-num {
                                width: 0.39rem;
                                height: 0.39rem;
                                background: #fff;
                                color: #3d5aa3;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                margin-right: 0.14rem;
                                position: relative;
                                z-index: 3;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 0.28rem;
                                font-weight: bold;
                            }
                        }

                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                height: 1.94rem;
            }
        }
    }
}
</style>
